export type RideStatus =
  | 'completed'
  | 'canceled'
  | 'memberNoShow'
  | 'driverNoShow'
  | 'onTime'
  | 'late'
  | 'avgMiles';

export const colors: Record<RideStatus, string> = {
  // completed: '#9F9FF8FF',
  completed: '#32936F78',
  canceled: '#BABABAFF',
  memberNoShow: '#ED6214FF',
  driverNoShow: '#4F7EFFFF',
  onTime: '#4F7EFF',
  late: '#ED6214FF',
  avgMiles: '#4F7EFFFF',
};

export type Status<K extends string = string> = {
  key: K;
  label: string;
  colorKey: RideStatus | string;
};

export const statusesRidesPie: Status[] = [
  { key: 'completedCount', label: 'Completed', colorKey: 'completed' },
  { key: 'memberNoShow', label: 'Inc - Member', colorKey: 'memberNoShow' },
  { key: 'driverNoShow', label: 'Inc - Driver', colorKey: 'driverNoShow' },
  { key: 'canceledCount', label: 'Canceled', colorKey: 'canceled' },
];

export const statusesRoutine: Status[] = [
  {
    key: 'lifeSustainingCount',
    label: 'Life Sustaining',
    colorKey: 'driverNoShow',
  },
  { key: 'routineCount', label: 'Routine', colorKey: 'completed' },
];

export const statusesRidesMembers: Status[] = [
  {
    key: 'members',
    label: 'Members',
    colorKey: 'driverNoShow',
  },
  {
    key: 'rides',
    label: 'Rides',
    colorKey: 'completed',
  },
];

export const statusesOnTimeLate: Status[] = [
  {
    key: 'onTime',
    label: 'On Time',
    colorKey: 'onTime',
  },
  {
    key: 'late',
    label: 'Late',
    // colorKey: 'late',
    colorKey: '',
  },
];

export const statusesAverageMiles: Status[] = [
  {
    key: 'avgMiles',
    label: 'Average Miles',
    colorKey: 'avgMiles',
  },
];

export const statusesCounty: Status[] = [
  {
    key: 'losAngeles',
    label: 'Los Angeles',
    colorKey: 'driverNoShow',
  },
  {
    key: 'contraCosta',
    label: 'Contra Costa',
    colorKey: 'completed',
  },
  {
    key: 'alpine',
    label: 'Alpine',
    colorKey: 'canceled',
  },
];
